import Orders from '../../views/orders/index.vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import i18nPlugin, { i18n, loadTranslations } from '../../i18n'

$.onmount('[data-vue=orders]', async function () {
  const initialData = JSON.parse(this.attributes['data-initial-data'].value)

  const pinia = createPinia()
  const app = createApp(Orders, { initialData })

  app.use(i18nPlugin)
  app.use(pinia)

  await loadTranslations(i18n)

  app.mount(this)
})
